export default __webpack_public_path__ + "static/media/BOWire3.992a3e3e.png";